<template lang="pug">
#filtrar-monitoramento-socioambiental
    .filtrar-monitoramento-socioambiental-container
        .filtrar-monitoramento-socioambiental-input-container
            .filtrar-monitoramento-socioambiental__input
                i.el-icon-search
                input(
                    v-model='pesquisa',
                    type='text',
                    placeholder='Buscar territórios monitorados por nome, CAR, pessoa, documento ou ID da pessoa',
                    autocomplete='off',
                    @keyup.enter='pesquisar',
                    @blur='fecharLista'
                )

            .filtrar-monitoramento-socioambiental__resultado
                transition(name='el-zoom-in-top')
                    ul.filtrar-monitoramento-socioambiental__ul(
                        v-if='mostrarResultado'
                    )
                        .mb-2(v-for='resultadoPesquisa in resultadosPesquisa')
                            span.filtrar-monitoramento-socioambiental__categoria(
                                v-if='resultadoPesquisa.resultado.length'
                            ) {{ resultadoPesquisa.categoria }}

                            li(
                                v-for='resultado in resultadoPesquisa.resultado',
                                @click='selecionarResultado(resultado)'
                            )
                                span {{ resultado.valor }}

        .filtrar-monitoramento-socioambiental__button
            el-popover(placement='bottom', width='500', trigger='click')
                el-button.button-outline(
                    icon='lyra-icon lyra-filtro',
                    name='filtro',
                    plain,
                    slot='reference'
                ) Filtros Avançados

                el-form.filtro(label-position='top')
                    .filtrar-monitoramento-socioambiental-popover-header
                        .filtrar-monitoramento-socioambiental-popover-header__text Filtros avançados
                        .filtrar-monitoramento-socioambiental-popover-header__link(
                            @click='aplicar'
                        )
                            | Aplicar filtro

                    .filtrar-monitoramento-socioambiental-popover-collapse
                        el-form-item.mb-0.filtro-accordion
                            el-collapse(
                                v-model='collapseFiltroAvancado',
                                accordion,
                                @change='abrirCollapse'
                            )
                                el-collapse-item(title='Biomas', name='biomas')
                                    .el-collapse-item__biomas--loading(
                                        v-loading='!biomas.length'
                                    )
                                        el-checkbox-group(
                                            v-model='biomasSelecionados',
                                            :max='1'
                                        )
                                            el-checkbox(
                                                v-for='(bioma, index) in biomas',
                                                :label='bioma',
                                                :key='index'
                                            )
                                                | {{ bioma.nome }}

                                el-collapse-item(
                                    title='UF/Município',
                                    name='estados'
                                )
                                    .filtrar-monitoramento-socioambiental-popover-collapse__select(
                                        v-loading='!estados.length'
                                    )
                                        div
                                            el-select(
                                                v-model='estadoSelecionado',
                                                filterable,
                                                value-key='id',
                                                @change='buscarMunicipios()',
                                                placeholder='UF'
                                            )
                                                el-option(
                                                    v-for='(estado, index) in estados',
                                                    :key='index',
                                                    :label='estado.nome',
                                                    :value='estado'
                                                ) {{ estado.nome }}
                                        div
                                            el-select(
                                                v-model='municipioSelecionado',
                                                filterable,
                                                value-key='id',
                                                placeholder='Município'
                                            )
                                                el-option(
                                                    v-for='(municipio, index) in municipios',
                                                    :key='index',
                                                    :label='municipio.nome',
                                                    :value='municipio'
                                                ) {{ municipio.nome }}

    .filtrar-monitoramento-socioambiental-filtro-selecionado
        span.filtrar-monitoramento-socioambiental-filtro-selecionado__titulo {{ $t('mensagens.blocoFiltros.uteis.filtrosSelecionados') }}
        el-tag.filtrar-monitoramento-socioambiental-filtro-selecionado__tag(
            v-for='tag in tags',
            :key='tag.nome',
            closable='',
            type='success',
            @close='removerFiltro(tag)'
        )
            span {{ getNome(tag.nome) }}

        el-tag.filtrar-monitoramento-socioambiental-filtro-selecionado__limpar(
            v-if='tags.length',
            type='info',
            @click='limparFiltros'
        ) Limpar filtros
            i.el-icon-delete

        span.filtrar-monitoramento-socioambiental-filtro-selecionado__nenhum(
            v-else
        ) Nenhum filtro selecionado
</template>

<script>
import MonitoramentoSocioambientalService from '@/services/MonitoramentoSocioambientalService';
import BiomaService from '@/services/BiomaService';
import LocalidadeService from '@/services/LocalidadeService';

export default {
    name: 'FiltrarMonitoramentoSocioambiental',

    /**
     * Retorno
     *
     * atualizar-filtro-avancado:
     * {
     *   idBiomas: [],
     *   idCategoriasFiltroAvancado: [],
     *   idRepresentantes: [],
     *   idTerritorios: []
     * }
     *
     */
    emits: ['atualizar-filtro-avancado', 'remover-categoria-selecionada'],
    props: {
        categoria: {
            type: Object,
            default: () => null
        }
    },
    data() {
        return {
            pesquisa: '',
            tags: [],
            collapseFiltroAvancado: [''],
            biomas: [],
            biomasSelecionados: [],
            estados: [],
            estadoSelecionado: {},
            municipios: [],
            municipioSelecionado: {},
            resultadosPesquisa: [],
            resultadosSelecionados: [],
            mostrarResultado: false,
            acaoCollapse: {
                biomas: {
                    collapse: 'biomas',
                    callback: 'buscarBioma'
                },
                estados: {
                    collapse: 'estados',
                    callback: 'buscarEstados'
                }
            },
            categorias: []
        };
    },
    watch: {
        categoria: function () {
            if (this.categoria !== null) {
                // Categoria selecionada
                if (this.categoria.classe !== '') {
                    let categoriaJaSelecionada = this.categorias.filter(
                        c => c.id === this.categoria.id
                    );

                    if (
                        !categoriaJaSelecionada ||
                        categoriaJaSelecionada.length === 0
                    ) {
                        this.categorias.push({
                            nome: this.categoria.nome,
                            codigo: 'CATEGORIA',
                            id: this.categoria.id
                        });
                    }
                    // Categoria desmarcada
                } else {
                    this.categorias = this.categorias.filter(
                        c => c.id !== this.categoria.id
                    );
                    this.tags = this.tags.filter(
                        tag => tag.nome !== this.categoria.nome
                    );
                }

                for (let tag of this.tags) {
                    if (tag && tag.codigo === 'CATEGORIA') {
                        this.tags = this.tags.filter(
                            value => value.codigo !== 'CATEGORIA'
                        );
                    }
                }

                this.tags = [...this.tags, ...this.categorias];
            }
        }
    },
    methods: {
        async pesquisar() {
            if (!this.pesquisa) return this.limpar();

            try {
                const { data } =
                    await MonitoramentoSocioambientalService.pesquisar(
                        this.pesquisa
                    );
                this.resultadosPesquisa = data;

                if (!data.length) {
                    this.mostrarResultado = false;
                    this.exibirNotify(
                        'warning',
                        'Não foram encontrados resultados com o texto informado. Verifique a informação inserida ou inicie um novo monitoramento.'
                    );
                } else {
                    this.mostrarResultado = true;
                }
            } catch (error) {
                this.exibirNotify(
                    'error',
                    'Não foi possível filtrar os dados de monitoramento.'
                );
                throw error;
            }
        },

        aplicar() {
            const filtros = {
                idBiomas: this.biomasSelecionados.map(b => b.id),
                idTerritorios: this.resultadosSelecionados
                    .map(t => t.filtro.idTerritorio)
                    .filter(t => t),
                idRepresentantes: this.resultadosSelecionados
                    .map(r => r.filtro.idRepresentante)
                    .filter(r => r)
            };

            this.tags = [
                ...this.biomasSelecionados,
                ...this.resultadosSelecionados,
                ...this.categorias
            ];

            if (this.estadoSelecionado.id && this.municipioSelecionado.id) {
                const estadoMunicipio = {
                    id: this.estadoSelecionado.id,
                    nome: `${this.municipioSelecionado.nome}/${this.estadoSelecionado.sigla}`,
                    codigo: 'ESTADO_MUNICIPIO'
                };
                this.tags.push(estadoMunicipio);
                filtros.idEstado = this.estadoSelecionado.id;
                filtros.idMunicipio = this.municipioSelecionado.id;
            } else {
                filtros.idEstado = '';
                filtros.idMunicipio = '';
            }

            if (this.categorias.length === 0) {
                filtros.idsCategorias = [];
            }

            this.tags.sort((a, b) => a.nome.localeCompare(b.nome));

            this.$emit('atualizar-filtro-avancado', filtros, null);
        },

        abrirCollapse(ref) {
            if (ref) {
                try {
                    const acao = this.acaoCollapse[ref];
                    if (!this[ref].length) {
                        this[acao.callback]();
                    }
                } catch (error) {
                    this.exibirNotify(
                        'error',
                        'Não foi possível buscar os dados.'
                    );
                    throw new Error(
                        'Ação não registrada para o collapse:' +
                            ref +
                            ', ERRRO:' +
                            error
                    );
                }
            }
        },

        removerFiltro(filtro) {
            this.tags.splice(this.tags.indexOf(filtro), 1);

            this.desmarcarFiltroPopover(filtro);

            this.aplicar();
        },

        desmarcarFiltroPopover(filtro) {
            this.biomasSelecionados = this.biomasSelecionados.filter(
                b => b.codigo !== filtro.codigo
            );
            this.resultadosSelecionados = this.resultadosSelecionados.filter(
                c => c.codigo !== filtro.codigo
            );
            if (filtro.codigo === 'ESTADO_MUNICIPIO') {
                this.estadoSelecionado = {};
                this.municipioSelecionado = {};
            }
            if (filtro.codigo === 'CATEGORIA') {
                this.$emit('remover-categoria-selecionada', filtro.id);
                this.categorias = this.categorias.filter(
                    value => value.id !== filtro.id
                );
            }
        },

        selecionarResultado(resultado) {
            this.adicionarResultado(resultado);

            this.aplicar();
        },

        adicionarResultado(resultado) {
            const filtro = {
                id:
                    resultado.filtro.idTerritorio ||
                    resultado.filtro.idRepresentante,
                filtro: resultado.filtro,
                nome: resultado.valor
            };
            filtro.codigo = `${filtro.id}_${filtro.nome}`;

            const adicionado = this.resultadosSelecionados.find(
                c => c.codigo === filtro.codigo
            );

            if (!adicionado) {
                this.resultadosSelecionados.push(filtro);
            }
        },

        limpar() {
            this.mostrarResultado = false;
            this.resultadosPesquisa = [];
        },

        fecharLista() {
            setTimeout(() => {
                this.mostrarResultado = false;
                this.resultadosPesquisa = [];
            }, 300);
        },

        buscarBioma() {
            BiomaService.buscar()
                .then(({ data }) => {
                    setTimeout(() => {
                        this.biomas = data;
                    }, 500);
                })
                .catch(error => {
                    this.exibirNotify(
                        'error',
                        'Não foi possível buscar os dados de biomas.'
                    );
                    throw error;
                });
        },

        buscarEstados() {
            LocalidadeService.findEstados(false)
                .then(({ data }) => {
                    setTimeout(() => {
                        this.estados = data;
                    }, 500);
                })
                .catch(error => {
                    this.exibirNotify(
                        'error',
                        'Não foi possível buscar os dados de estados.'
                    );
                    throw error;
                });
        },

        buscarMunicipios() {
            LocalidadeService.findMunicipios(this.estadoSelecionado.id, false)
                .then(({ data }) => {
                    this.municipioSelecionado = null;
                    setTimeout(() => {
                        this.municipios = data;
                    }, 500);
                })
                .catch(error => {
                    this.exibirNotify(
                        'error',
                        'Não foi possível buscar os dados de municipio.'
                    );
                    throw error;
                });
        },

        exibirNotify(tipo, message) {
            this.$notify[tipo]({
                message
            });
        },

        limparFiltros() {
            this.biomasSelecionados = [];
            this.resultadosSelecionados = [];
            this.estadoSelecionado = {};
            this.municipioSelecionado = {};
            this.categorias = [];

            this.tags.forEach(tag => {
                if (tag.codigo === 'CATEGORIA') {
                    setTimeout(() => {
                        this.$emit('remover-categoria-selecionada', tag.id);
                    }, 500);
                }
            });

            this.tags = [];

            this.aplicar();
        },

        getNome(nome) {
            if (nome.includes('Representantes')) {
                return 'Pessoas';
            } else {
                return nome;
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.filtrar-monitoramento-socioambiental-container {
    display: flex;
    justify-content: space-between;
}

.filtrar-monitoramento-socioambiental-input-container {
    width: 100%;
    height: 42px;
    border-radius: 5px;
    background: var(--white);
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
    position: relative;
    margin-right: 10px;
}

.filtrar-monitoramento-socioambiental__resultado {
    position: absolute;
    width: 100%;
}

.filtrar-monitoramento-socioambiental__resultado__nome {
    margin: 0px 10px;
}

.filtrar-monitoramento-socioambiental__input {
    height: 100%;
    display: flex;
    justify-content: center;

    i.el-icon-search {
        color: var(--primary);
        font-size: 25px;
        font-weight: bold;
        display: flex;
        align-items: center;
        margin: 0 8px;
    }

    input {
        width: 100%;
        height: 100%;
        border: none;
        outline: none;
        border-radius: 5px;
        color: var(--primary);
    }
}

.filtrar-monitoramento-socioambiental__ul {
    list-style: none;
    padding: 8px 0 8px 24px;
    position: relative;
    z-index: 42;
    margin-top: 5px;
    border-radius: 5px;
    background-color: var(--white);
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);

    li {
        padding-left: 18px;
        margin-top: 5px;
        cursor: pointer;
    }
}

.filtrar-monitoramento-socioambiental__categoria {
    font-weight: bold;
}

.filtrar-monitoramento-socioambiental-filtro-selecionado {
    margin-top: 15px;
    min-height: 42px;
}

.filtrar-monitoramento-socioambiental-filtro-selecionado__titulo {
    font-size: 18px;
    font-weight: 100;
}

.filtrar-monitoramento-socioambiental-filtro-selecionado__tag {
    margin: 0px 5px 10px 5px;
}

.filtrar-monitoramento-socioambiental-filtro-selecionado__limpar {
    margin: 0px 5px 10px 5px;
    i {
        padding-left: 5px;
    }
}

.filtrar-monitoramento-socioambiental-filtro-selecionado__nenhum {
    margin-left: 5px;
    font-weight: 100;
    font-style: italic;
    font-size: 14px;
}

.filtrar-monitoramento-socioambiental-popover-header {
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;

    .filtrar-monitoramento-socioambiental-popover-header__text {
        color: var(--primary);
        font-weight: 600;
    }
    .filtrar-monitoramento-socioambiental-popover-header__link {
        color: #1989fa;
        text-decoration: underline;
        cursor: pointer;
    }
}

.filtrar-monitoramento-socioambiental-popover-collapse {
    .el-select {
        width: 100%;
    }
    .el-collapse-item__header {
        font-weight: 500;
    }
    .filtro-accordion {
        margin-top: 10px;
    }
    .el-checkbox,
    .el-radio {
        margin-right: 12px !important;
        min-width: 200px;
        line-height: 2;
    }
    .el-checkbox-group,
    .el-radio-group {
        display: flex;
        flex-wrap: wrap;
    }
}

.filtrar-monitoramento-socioambiental-popover-collapse__select {
    display: flex;
    justify-content: space-between;
}

.button-outline {
    border-color: var(--primary) !important;
    color: var(--primary) !important;
    background: transparent !important;
    display: flex;
    align-items: center;

    .lyra-filtro:before {
        content: '';
        width: 15px !important;
        height: 12px !important;
        background-color: var(--primary) !important;
        margin-right: 6px;
    }
}

.el-collapse-item__categorias--loading {
    min-height: 76px;
}

.el-collapse-item__biomas--loading {
    min-height: 100px;
}

.el-tag {
    border-radius: 20px !important;
}

.el-tag.el-tag--success {
    border-color: var(--secondary-two) !important;
    color: var(--white) !important;
    background: var(--secondary-two) !important;
}

span.filtrar-monitoramento-socioambiental-filtro-selecionado__limpar.el-tag.el-tag--info.el-tag--light {
    cursor: pointer;
}
</style>
